import React, { useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import Joi from "joi";
import {
  FormControl,
  Grid,
  TextField,
  Alert,
  Snackbar,
  Divider,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import LockResetIcon from "@mui/icons-material/LockReset";

import { getCookie } from "../../shared/getCookie";
import API_REQ from "../../shared/API_REQ";

export default function ForgetPassword() {
  const navigate = useNavigate();
  const formEl = useRef();

  const [isLoggedIn, setIsLoggedIn] = useState(getCookie("token"));
  const [isSent, setIsSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [values, setValues] = useState({
    email: "",
  });
  const [errors, setErrors] = useState({});

  const forgotPasswordSchema = Joi.object({
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required(),
  });

  const submitHandler = (e) => {
    e.preventDefault();
    setIsLoading(true);
    API_REQ.post("/user/forgotPassword", values)
      .then(({ data }) => {
        setIsSent(true);
        setIsLoading(false);
        setIsError(false);
      })
      .catch((err) => {
        setIsSent(false);
        setIsLoading(false);
        setIsError({
          message: err?.response?.data,
        });
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });

    const result = forgotPasswordSchema.validate(values);
    if (result.error) {
      const errors = {};
      for (let item of result.error.details) {
        errors[item.path[0]] = item.message;
      }
      setErrors(errors);
    } else {
      setErrors({});
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      navigate("/");
    }
  }, []);

  return (
    <div className="page page-resetPassword">
      <Grid container rowSpacing={4} m="auto" style={{ maxWidth: "700px" }}>
        <Grid item align="center" xs={12}>
          <img
            className="logo"
            src="/assets/images/icon-only-white.png"
            alt="Logo"
          />
        </Grid>
        <Grid item xs={12}>
          <legend style={{ fontSize: 26, fontWeight: 700 }}>
            Reset Password:
          </legend>
        </Grid>

        <Grid item xs={12}>
          <form
            className="form form-login"
            ref={formEl}
            onSubmit={submitHandler}
            onChange={handleChange}
          >
            <Grid container rowSpacing={2} columnSpacing={4}>
              <Grid item xs={12}>
                <FormControl
                  style={{
                    width: "100%",
                    padding: 0,
                  }}
                >
                  <TextField
                    label="Email"
                    id="email"
                    name="email"
                    autoComplete="off"
                    aria-describedby="email"
                    autoFocus
                    required
                    value={values.email}
                    type="email"
                    error={errors["email"] ? true : false}
                  />
                </FormControl>
              </Grid>
              <Grid align="right" item sm={12}>
                <Link to="/user/login">Sign in</Link>
              </Grid>
              <Grid item xs={12}>
                <Snackbar
                  autoHideDuration={5000}
                  open={isError ? true : false}
                  onClose={() => {
                    setIsError(false);
                  }}
                >
                  <Alert sx={{ mb: 2 }} severity="error">
                    {isError.message || "Error"}
                  </Alert>
                </Snackbar>
                <Snackbar
                  autoHideDuration={3000}
                  open={isSent ? true : false}
                  onClose={() => {
                    navigate("/user/login");
                  }}
                >
                  <Alert sx={{ mb: 2 }} severity="success">
                    Reset link is sent to your Email !
                  </Alert>
                </Snackbar>
                <LoadingButton
                  loading={isLoading}
                  type="submit"
                  variant="contained"
                >
                  Reset{" "}
                  <LockResetIcon fontSize="small" style={{ margin: "0 8px" }} />
                </LoadingButton>
              </Grid>
            </Grid>
          </form>
        </Grid>
        <Grid item xs={12}>
          <Divider />
          <p>
            Need an account?{" "}
            <Link className="link" to="/user/register">
              Sign up
            </Link>
          </p>
        </Grid>
      </Grid>
    </div>
  );
}
